import Loadable from '../../components/Loadable'

const AsyncSimulation = Loadable({
  loader: () => import('../Simulation')
})

const AsyncPersonalInformation = Loadable({
  loader: () => import('../PersonalInformation')
})

const AsyncUploadDocuments = Loadable({
  loader: () => import('../UploadDocuments')
})

const AsyncSummary = Loadable({
  loader: () => import('../Summary')
})


export default [{
  title: 'COTIZA TU CRÉDITO',
  content: AsyncSimulation,
  // icon: 'file-sync',
  icon: '1',
  path: '/simulacion'
}, {
  title: 'DATOS PERSONALES',
  content: AsyncPersonalInformation,
  icon: '2',
  path: '/simulacion/informacion-personal'
}, {
  title: 'SUBIR DOCUMENTOS',
  content: AsyncUploadDocuments,
  icon: '3',
  path: '/simulacion/documentos'
}, {
  title: 'RESUMEN SOLICITUD',
  content: AsyncSummary,
  icon: '4',
  path: '/simulacion/finalizar'
}]
